export default __webpack_public_path__ + "static/media/slot3.8646b426.png";